import { Address, Card, Payer, SessionResponse } from '@finteqhub/sdk-js';

import { PaymentMethodInput } from '@cashier/cashier-model';

interface FormAccountPayload {
  customerAccountId: string;
  credentials: {
    card: {
      cvv: string;
    };
    payer: Payer;
    billingAddress: Address;
  };
  paymentMethod: string;
}

interface FormStandardPayload {
  credentials: {
    card: Card;
    payer: Payer;
    billingAddress: Address;
  };
  paymentMethod: string;
}

export const DataConverter = {
  toFormPayload: (
    session: SessionResponse,
    paymentInputs: Record<string, PaymentMethodInput>,
    externalAccountId?: string,
  ): FormAccountPayload | FormStandardPayload => {
    if (externalAccountId) {
      return {
        customerAccountId: externalAccountId,
        credentials: {
          card: {
            cvv: String(paymentInputs['cvv'].value),
          },
          payer: session.initCredentials.payer,
          billingAddress: session.initCredentials.billingAddress,
        },
        paymentMethod: session.operation['paymentMethod'] || '',
      };
    }

    const [cardExpireMonth, cardExpireYear] = (
      paymentInputs['expirationDate'].value as string
    ).split('/');

    return {
      credentials: {
        card: {
          number: String(paymentInputs['creditcardNumber'].value),
          holder: String(paymentInputs['cardHolder'].value),
          expiryMonth: Number(cardExpireMonth),
          expiryYear: Number(cardExpireYear),
          cvv: String(paymentInputs['cvv'].value),
          tokenize: true,
        },
        payer: session.initCredentials.payer,
        billingAddress: session.initCredentials.billingAddress,
      },
      paymentMethod: session.operation['paymentMethod'] || '',
    };
  },
};
